import moment from 'moment'

export const electColumnsFilter = [
  {
    active: true,
    headerName: 'Regional',
    field: 'nome_regional',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'nome_distrito',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'eleito_nome',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ',
    field: 'eleito_doc',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Nome do contato',
    field: 'eleito_contact_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'E-mail',
    field: 'eleito_contact_email',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Telefone',
    field: 'eleito_contact_phone_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Local',
    field: 'local_nome',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Contato do local',
    field: 'local_contact_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'E-mail do local',
    field: 'local_contact_email',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Telefone do local',
    field: 'local_contact_phone_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Endereço',
    field: 'local_endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Número',
    field: 'local_numero_endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Bairro',
    field: 'local_bairro_endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Cidade',
    field: 'local_cidade_endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Complemento',
    field: 'local_complemento_endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Pertence a carteira',
    field: 'is_district_wallet',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (value === true ? 'SIM' : 'NÃO')
  },
  {
    active: true,
    headerName: 'Classificação do agricultor',
    field: 'customer_type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: `Consultoria Líderes da Soja`,
    field: 'top_consultants_types',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação do local',
    field: 'location_type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Área Forecast',
    field: 'areaplantada',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : parseInt(value, 10) + ' ha'),
    isNumber: true
  },
  {
    active: true,
    headerName: 'Área Real',
    field: 'area_from_location',
    cellRenderer: ({ value }) => (!value ? ' - ' : parseInt(value, 10) + ' ha'),
    isNumber: true
  }
]

export const alternativeColumnsFilter = [
  {
    active: true,
    headerName: 'Regional',
    field: 'nome_regional',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'nome_distrito',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Grupo',
    field: 'group_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Nome do alternativo',
    field: 'nome_alternativo',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ Original',
    field: 'document_original',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ Alternativo',
    field: 'document_alternative',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Vínculo',
    field: 'tipo_de_vinculo',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Status',
    field: 'approval_status',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Original',
    field: 'original',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const actionColumnsFilter = [
  {
    active: true,
    headerName: 'Regional',
    field: 'region_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Status',
    field: 'action_status',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value.replace('_', ' '))
  },
  {
    active: true,
    headerName: 'Tipo de visita',
    field: 'tipo_da_visita',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Profissional',
    field: 'member_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo de agricultor',
    field: 'tipo_eleito',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ Agricultor',
    field: 'document_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Local',
    field: 'location_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação do local',
    field: 'location_type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const actionDetailColumnsFilter = [
  {
    active: true,
    headerName: 'Descrição',
    field: 'action_subject',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo de Visita',
    field: 'tipo_da_visita',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Status da Visita',
    field: 'action_status',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value.replace('_', ' '))
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ',
    field: 'document_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Profissional',
    field: 'member_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Local',
    field: 'location_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Regional',
    field: 'region_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Safra',
    field: 'period_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data de execução da Visita',
    field: 'data_da_visita',
    filter: 'agDateColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    filterParams: {
      comparator: (filter, value) => {
        const momentFilter = moment(filter).format('YYYY/MM/DD')
        const momentValue = moment(value).format('YYYY/MM/DD')

        if (momentFilter > momentValue) {
          return -1
        } else if (momentValue > momentFilter) {
          return 1
        }
        return 0
      }
    }
  },
  {
    active: true,
    headerName: 'Ações executadas com planejamento',
    field: 'plannedactions',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Ações Executadas sem Planejamento',
    field: 'notplannedactions',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Time',
    field: 'organization_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const forecastColumnsFilter = [
  {
    active: true,
    headerName: 'Regional',
    field: 'regional_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ Agricultor',
    field: 'document_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data',
    field: 'forecast_date',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo do item',
    field: 'item_type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tecnologia',
    field: 'technology',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo',
    field: 'type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Processos comerciais previstos',
    field: 'predicted_commercial_processes',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Área',
    field: 'area',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : parseInt(value, 10))
  },
  {
    active: true,
    headerName: 'Janeiro',
    field: 'jan',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Fevereiro',
    field: 'fev',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Março',
    field: 'mar',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Abril',
    field: 'abr',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Maio',
    field: 'mai',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Junho',
    field: 'jun',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Julho',
    field: 'jul',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agosto',
    field: 'ago',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Setembro',
    field: 'set',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Outubro',
    field: 'out',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Novembro',
    field: 'nov',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Dezembro',
    field: 'dez',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Última atualização',
    field: 'lastUpdate',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const arrastaoColumnsFilter = [
  {
    active: true,
    headerName: 'Regional',
    field: 'region_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data',
    field: 'cultivars_date',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ Agricultor',
    field: 'document_number',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Material',
    field: 'material_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Área',
    field: 'area',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : Number(value))
  },
  {
    active: true,
    headerName: 'Geração de Demanda',
    field: 'demand',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Arrastão',
    field: 'type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tecnologia',
    field: 'technology',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Marca',
    field: 'brand',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Última atualização',
    field: 'ultima_atualizacao',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const cargaDadosColumnsFilter = [
  {
    active: true,
    headerName: 'Arquivo',
    field: 'nomearquivo',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo de Importação',
    field: 'descricao',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data',
    field: 'data_carga',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : moment(value.slice(0, 10)).format('DD/MM/YYYY'))
  },
  {
    active: true,
    headerName: 'Status',
    field: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Usuário',
    field: 'username',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]

export const ReportOfFarmersPortfolioColumnsFilter = [
  {
    active: true,
    headerName: 'Safra',
    field: 'safraeib'
  },
  {
    active: true,
    headerName: 'Status da Carteira',
    field: 'status'
  },
  {
    active: true,
    headerName: 'Regional',
    field: 'region_name'
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name'
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name'
  },
  {
    active: true,
    headerName: 'Distrito Focal',
    field: 'focal_district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'RTV Focal',
    field: 'focal_member_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ',
    field: 'document_number'
  },
  {
    active: true,
    headerName: 'E-mail do Agricultor',
    field: 'email_address'
  },
  {
    active: true,
    headerName: 'Telefone do Agricultor',
    field: 'phone_number'
  },
  {
    active: true,
    headerName: 'Local',
    field: 'location_name'
  },
  {
    active: true,
    headerName: 'Contato do local',
    field: 'contato_local'
  },
  {
    active: true,
    headerName: 'E-mail do local',
    field: 'contato_email'
  },
  {
    active: true,
    headerName: 'Telefone do local',
    field: 'contato_phone'
  },
  {
    active: true,
    headerName: 'Endereço',
    field: 'address_description'
  },
  {
    active: true,
    headerName: 'Número',
    field: 'address_number'
  },
  {
    active: true,
    headerName: 'Bairro',
    field: 'neighborhood'
  },
  {
    active: true,
    headerName: 'Cidade',
    field: 'city_state_name'
  },
  {
    active: true,
    headerName: 'UF',
    field: 'uf'
  },
  {
    active: true,
    headerName: 'Complemento',
    field: 'address_complement'
  },
  {
    active: true,
    headerName: 'Classificação do agricultor',
    field: 'eibClassificacao'
  },
  {
    active: true,
    headerName: 'Classificação do local',
    field: 'type_name'
  },
  {
    active: true,
    headerName: 'Área',
    field: 'areaPlantada'
  }
]

export const actionPlanColumnFilter = [
  {
    active: true,
    headerName: 'Safra EIB',
    field: 'safraEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Regional',
    field: 'regional',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'distrito',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Profissional',
    field: 'profissional',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'agricultor',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'CPF/CNPJ',
    field: 'cpf_cnpj',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Local',
    field: 'local',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Endereço',
    field: 'endereco',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Número',
    field: 'numero',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Bairro',
    field: 'bairro',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Cidade',
    field: 'cidade',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Complemento',
    field: 'complemento',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação do agricultor',
    field: 'classificacaoagricultor',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação do local',
    field: 'classificacaoLocal',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação EIB',
    field: 'classificacaoEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? 0 : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Pontuação EIB',
    field: 'pontuacaoEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? 0 : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Categoria ação EIB',
    field: 'categoriaAcaoEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? 0 : value)
  },
  {
    active: true,
    headerName: 'Nome da ação EIB',
    field: 'nomeAcaoEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Classificação da ação EIB',
    field: 'classificacaoAcaoEib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? 0 : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Status de planejamento EIB',
    field: 'statusplanejamentoeib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Status de execução EIB',
    field: 'statusexecucaoeib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tipo de visita',
    field: 'action_type',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data da visita',
    field: 'action_created',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Data da finalização da visita',
    field: 'action_executed',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Id da visita',
    field: 'id_visita',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value),
    cellStyle: { textAlign: 'right' }
  },
  {
    active: true,
    headerName: 'Participante EIB',
    field: 'is_eib',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  }
]
